import SurveyContainer from './SurveyContainer';

export default SurveyContainer;
